<template>
  <main class="page standards">
    <section class="section page__header">
      <h1 class="title">Приказы</h1>
    </section>

    <section class="section page__content">
      <div class="page__row page__row_between mb-30">
        <div class="page__row">
          <div class="page__item page__search">
            <AppSelect title="Год приказа"
                       :value="default_year"
                       placeholder="Выбрать"
                       :options="yearList"
                       @value-changed="setDefaultYear"
            />
          </div>
        </div>
        <div class="page__item" style="margin-left: auto;">
          <div class="page__row">
            <transition name="fade">
              <div class="page__item" v-if="isVisibleBtnRemove">
                <AppButtonSmRemove
                  title="Удалить"
                  @click.stop.native="showRemoveConfirmationGroup"
                />
              </div>
            </transition>
            <AppButtonSmAdd title="Создать" @click.native="modalVisible = true" />
          </div>
        </div>
      </div>
      <AppTable
        v-if="isVisibleTable"
        :data="standardsDecreesList"
        :headers="table.headers"
        :loading="false"
        has-checkbox
        :all-items-active="table.allActive"
        isSpecial
        @toggle-active-item="toggleActiveItem"
        @toggle-active-all="toggleActiveAll"
        @show-this-item="goToUpdate"
        @remove-this-item="showRemoveConfirmation"
      />
    </section>

    <section class="section page__footer">
      <VPagination
        v-if="isVisibleTable"
        :pageList="pagination.pageList"
        :currentPage="pagination.currentPage"
        @get-page="getPage"
      />
    </section>

    <BaseModal
      v-if="modalVisible"
      @close="modalVisible = false"
      title="Добавить приказ"
    >
      <StandardsDecreesForm
        @constructingSubmit="createDecreesSubmit"
        @cancel="modalVisible = false"
      />
    </BaseModal>

    <transition name="fade">
      <AppConfirmation
        v-if="removeConfirmation.active && isVisibleBtnRemove"
        :text="removeConfirmation.group ? 'Вы действительно хотите удалить эти приказы?' : 'Вы действительно хотите удалить эти приказы?'"
        @confirm="removeConfirmation.group ? deleteDecreesChecked() : deleteDecreesChecked()"
        @reject="closeRemoveConfirmation"
      />
    </transition>

  </main>
</template>

<script>

import AppButtonSmRemove from '@/components/page/button/AppButtonSmRemove'
import AppButtonSmAdd from '@/components/page/button/AppButtonSmAdd'
import AppTable from '@/components/page/table/AppTable'
import VPagination from '@/components/page/VPagination'
import AppConfirmation from '@/components/page/modal/AppConfirmation'
import AppSelect from '@/components/page/input/AppSelect'
import BaseModal from '@/components/page/modal/base/BaseModal'
import StandardsDecreesForm from '@/components/standards/form/StandardsDecreesForm'
import { MOCKS_DECREES } from '@/mocks/table-mock'
import { MOCKS_YEAR } from '@/mocks/select-mock'
import { deleteToggleItems, toggleAll, toggleItem } from '@/utils/table/table'
import { nanoid } from 'nanoid'

// заглушка
const pages = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

export default {
  name: 'StandardsDecrees',

  components: {
    StandardsDecreesForm,
    AppButtonSmRemove,
    AppButtonSmAdd,
    AppTable,
    VPagination,
    AppConfirmation,
    AppSelect,
    BaseModal
  },

  data: () => ({

    // таблица
    table: {
      allActive: false,
      headers: [
        {
          title: '№',
          isSortable: true
        },
        {
          title: 'Вид документа',
          isSortable: true
        },
        {
          title: 'Тема',
          isSortable: true
        },
        {
          title: '№ документа',
          isSortable: true
        },
        {
          title: 'Дата регистрации',
          isSortable: true
        },
        {
          title: 'Исполнитель',
          isSortable: true
        },
        {
          title: 'Ответственный',
          isSortable: true
        },
        {
          title: 'Прикрепленные файлы',
          isSortable: true
        }
      ]
    },

    // пагинация
    pagination: {
      currentPage: 1,
      pageList: {
        active: false,
        pages
      }
    },

    isVisibleBtnRemove: false,

    // Заглушкa
    standardsDecreesList: MOCKS_DECREES,
    // заглушка для селекта
    yearList: MOCKS_YEAR,

    removeConfirmation: {
      active: false,
      id: null,
      group: false
    },

    default_year: null,
    // модалка
    modalVisible: false,

    user: {
      profile: {
        full_name: 'Администратор @admin'
      },
      avatar: {
        url: '/img/avatar-thumb.png'
      }
    },
    countFiles: {
      count: '8 файлов'
    }

  }),

  computed: {
    isVisibleTable () {
      return this.standardsDecreesList.length
    }
  },

  methods: {

    setDefaultYear (value) {
      this.default_year = value
    },

    // редактирование
    goToUpdate (id) {
      this.$router.push({ name: 'StandardsDecreesUpdate', params: { id_standards_decrees: id } })
    },

    async createDecreesSubmit (data) {
      try {
        const mockData = [
          { data: `${1}` },
          { data: 'Приказ' },
          { data: 'Тест тема' },
          { data: '123' },
          { data: '10.03.2022' },
          { data: this.user, mod: 'avatar' },
          { data: this.user, mod: 'avatar' },
          { data: this.countFiles, mod: 'countFiles' }
        ]

        const standardsDecreesItem = {
          id: nanoid(),
          isActive: false,
          values: mockData
        }

        this.standardsDecreesList.push(standardsDecreesItem)
        console.log('createDecreesSubmit', data)
      } catch (e) {
        console.log(e)
      } finally {
        this.modalVisible = false
      }
    },

    toggleActiveItem (itemId) {
      this.isVisibleBtnRemove = toggleItem(itemId, this.standardsDecreesList)
    },

    toggleActiveAll () {
      this.isVisibleBtnRemove = toggleAll(this.table, this.standardsDecreesList)
    },

    showRemoveConfirmation (id) {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = id
      console.log('id', id)
    },
    closeRemoveConfirmation () {
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
    },
    showRemoveConfirmationGroup () {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = null
      this.removeConfirmation.group = true
    },
    deleteDecreesChecked () {
      this.removeConfirmation.active = false
      this.standardsDecreesList = deleteToggleItems(this.standardsDecreesList)
      this.removeConfirmation.group = false
      this.table.allActive = false
      this.isVisibleBtnRemove = false
    },

    // пагинация
    getPage (pageNum) {
      this.pagination.currentPage = pageNum
    }
  },
  destroyed () {
    this.decreesList.find(item => { item.isActive = false })
    this.isVisibleBtnRemove = false
  }
}
</script>

<style>
.input__text {
  color: #697178;
  margin-bottom: 10px;
  font-weight: 600;
}
</style>
